import { AudienceCount } from '../domain';
import { useTranslation } from '../hooks';
import { AudienceCountsTable } from './audienceCountsTable';
import { PercentageInsightPanel, PercentageInsightPanelProps } from './PercentageInsightPanel';

type UnsubscribeRatePanelProps = Omit<PercentageInsightPanelProps, 'children'> & {
  sent?: number;
  unsubscribed?: number;
};

export const UnsubscribeRatePanel = ({
  title,
  percentage,
  sent = 0,
  unsubscribed = 0,
}: UnsubscribeRatePanelProps) => {
  const { t } = useTranslation();
  const details: AudienceCount[] = [
    {
      name: t('insights.totalUnsubscribed'),
      count: unsubscribed,
    },
    {
      name: t('insights.totalSent'),
      count: sent,
    },
  ];

  const hasUnsubscribedMetrics = Boolean(sent + unsubscribed);

  return (
    <PercentageInsightPanel title={title} percentage={percentage} isEmpty={!hasUnsubscribedMetrics}>
      {hasUnsubscribedMetrics && <AudienceCountsTable values={details} />}
    </PercentageInsightPanel>
  );
};
